<template>
  <a-layout-sider
    :class="['sider', theme]"
    width="240px"
    :collapsible="collapsible"
    :collapsedWidth="firstClick ? '140' : '120'"
    v-model="collapsed"
    :trigger="null">
    <div class="logo" v-show="!collapsed"></div>
    <div class="logo-hidden" v-show="collapsed"></div>
    <div class="side-content">
      <div class="side-content-menu " :class="collapsed ? 'side-content-menu-hidden' :''">
        <div class="one-menu" :class="[collapsed ? 'one-menu-hidden ' :'',itemActive == '10' ? 'one-menu-hover' : '']"
             @click="itemClick(10)">
          <a-tooltip placement="bottom" overlayClassName='menu-pop'>
            <template slot="title">
              <span>首页</span>
            </template>
            <div class="menu-bg home"
                 :class="[collapsed ? 'menu-bg-hidden menu-icon-hidden': '',itemActive == '10' ? 'menu-bg-active' : '']">
            </div>
          </a-tooltip>
        </div>
        <div
          v-for="(item,index) in apps" :key="index"
          class="one-menu"
          :class="[collapsed ? 'one-menu-hidden ' :'',itemActive == item.app_uuid ? 'one-menu-hover' : '']"
          @click="itemClick(20,item.app_uuid)">
          <a-tooltip placement="bottom" overlayClassName='menu-pop'>
            <template slot="title">
              <span>{{item.app_name}}</span>
            </template>
            <div class="menu-bg"
                 :class="[collapsed ? 'menu-bg-hidden menu-icon-hidden': '', item.ico_index == 'eams_icon' ? 'eams' : item.ico_index == 'oa_icon' ? 'oa' : item.ico_index == 'sp_icon' ? 'sp': item.ico_index == 'egw_icon' ? 'egw':item.ico_index == 'sw_icon' ? 'sw' : item.ico_index == 'setting-icon' ? 'setting' : 'default',itemActive == item.app_uuid ? 'menu-bg-active' : '']">
            </div>
          </a-tooltip>
        </div>
        <div class="one-menu" v-if="apps.length == 0 && menus.length >0"
             :class="[collapsed ? 'one-menu-hidden' :'',itemActive == '30' ? 'one-menu-hover' : '']"
             @click="itemClick(30)">
          <div class="menu-bg setting" :class="collapsed ? 'menu-bg-hidden menu-icon-hidden': ''">
          </div>
        </div>
      </div>

      <div class="menu-div">
        <!-- 第一个选中时的列表，可新增 -->
        <ul class="first-menu" :style="{'width':(collapsed ? '80px' : '160px')}" v-show="firstClick"
            style="background-color:#72C7C2">
          <li class="first-one-menu" @click="goTodo(item)" v-for="(item,index) in quickList" :key="index">
            <div class="first-one-bg" :style="{'left':(collapsed ? '19px' : '58px')}">
            </div>
            <span class="ecp-icon ecp-icon-wodedaiban1 font24 first-one-icon"
                  :style="{'left': (collapsed ? '28px' : '67px')}"></span>
            <div class="first-one-title font12">{{item.menuname}}</div>
          </li>
          <li class="first-one-menu" @click="addQuick">
            <div class="first-one-bg" :style="{'left':(collapsed ? '19px' : '58px')}">
            </div>

            <span class="ecp-icon ecp-icon-tianjia font24 first-one-icon"
                  :style="{'left': (collapsed ? '27px' : '66px')}"></span>
            <div class="first-one-title font12">添加</div>
          </li>
        </ul>
        <!-- 新的菜单栏 -->
        <a-menu
          mode="inline"
          style="background-color:#72C7C2;color:white "
          @click="onSelect"
          @openChange='openChange'
          :openKeys="openKeys"
          :style="{'width':(collapsed ? '60px' : '160px')}"
          v-show="!firstClick"
        >
          <template v-for="item in menus">
            <a-menu-item v-if="!item.children" :key="item.key" :data="item.data" style="line-height:50px;height:50px">
              <!-- <ecp-icon type="iconfawenguanli" style="font-size:17px" class="middle"/> -->
            </a-menu-item>
            <sub-menu v-else :menu-info="item" :subMenuCloseDelay="5" :key="item.key"/>
          </template>
        </a-menu>
      </div>
      <footer class="add-tree" ref="addTree">
        <a-modal
          title="添加快捷菜单"
          :width="720"
          :visible="addShow"
          v-show="addShow"
          class="menu-footer"
          :closable=false
          :confirmLoading="confirmLoading"
          :destroyOnClose='true'
          >
          <div class="add-tree-content">
            <div>全部菜单</div>
            <a-tree
              @expand="onExpand"
              :treeData="treeData"
              checkable
              @check="treeCheck"
              :expandedKeys="expandedKeys"
              :autoExpandParent='autoExpandParent'
              v-model="checkKeys"
            >
            <a-icon slot="switcherIcon" type="down" />
            </a-tree>
          </div>
          <div class="add-tree-list">
            <div>已选菜单</div>
            <draggable
              :list="rightSort"
              style="padding-top:7px;padding-left:16px"
              ghost-class="ghost"
              class="list-group"
            >
              <div v-for="(item,key) in rightSort" :key="item.menucode" :index="key" class="list-group-item">
                <span class="add-tree-index">
                  <span v-if="key<9">0</span>
                  <span>{{key+1}}</span>
                  </span>
                {{item.menuname}}
              </div>
            </draggable>
          </div>
          <template slot="footer">
            <a-button key="submit" type="primary" @click="handleTreeOk" style="background-color:#569DDA;border:0">
              确定
            </a-button>
            <a-button key="back"  type="primary" @click="handleCancel"  style="background-color:#FF406D;border:0">关闭</a-button>
          </template>
        </a-modal>
      </footer>
    </div>
  </a-layout-sider>

</template>

<script>
  import SubMenu from './SubMenu'
  import {Icon} from 'ant-design-vue'
  import {mapGetters} from 'vuex'
  import draggable from 'vuedraggable'
  import {menuLoad, pbService, menuCode2RealUrl, addQuickList, queryQuickList} from '../../api/manage'


  const EcpIcon = Icon.createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_1492035_3rwvb99de0q.js'
  })
  export default {
    name: 'SideMenu',
    data() {
      return {
        firstClick: true,
        itemActive: '10',
        oaIcon: require('../../assets/home/file-manage.png'),
        egwIcon: require('../../assets/home/message-send.png'),
        swIcon: require('../../assets/home/all-manage.png'),
        defaultIcon: require('../../assets/home/no-icon.png'),
        addShow: false,
        confirmLoading: false,
        treeData: [],
        checkKeys: [],
        selectArray: [],
        quickList: [],
          resultList:[],
        expandedKeys: [],
        autoExpandParent: true,
        rightSort: [],   // 排序的数组
        openKeys: [],
        // rootSubmenuKeys:[]
      }
    },

    components: {
      SubMenu,
      EcpIcon,
      draggable
    },

    computed: {
      ...mapGetters(['apps', 'userInfo']),
      menuMap() {
        return this._loopMenu(this.menus)
      },
      // openKeys() {
      //   let arr = []
      //   return arr.push(this.menus[0].key)
      // },
      rootSubmenuKeys() {
        if (this.menus.length>0) {
          let arr = []
          for(let i of this.menus) {
            arr.push(i.key)
          }
          return arr
        }
      }
    },

    props: {
      mode: {
        type: String,
        required: false,
        default: 'inline'
      },
      theme: {
        type: String,
        required: false,
        default: 'dark'
      },
      collapsible: {
        type: Boolean,
        required: false,
        default: false
      },
      collapsed: {
        type: Boolean,
        required: false,
        default: false
      },
      menus: {
        type: Array,
        required: true
      }
    },

    created() {
      // 查找快捷方式方法
      console.log(this.menus);
      this.loadQuickList().then(res => {
        this.loadTreeData()
        let array = []
        for (let i of res) {
          if (array.indexOf(i.parentmenucode) === this.$TREE_ROOT) {
            array.push(i.parentmenucode)
          }
        }
        this.expandedKeys = array
      })
    },

    methods: {
      onSelect(obj) {
        obj.data = this.menuMap[obj.key].data
        this.$emit('select', obj)
      },

      openChange(openKeys) {
        const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1);
        if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
          this.openKeys = openKeys;

        } else {

          this.openKeys = latestOpenKey ? [latestOpenKey] : [];
        }
      },

      _loopMenu(menus) {
        let res = {}
        for (const m of menus) {
          res[m.key] = m
          if (m.children) {
            res = {...this._loopMenu(m.children), ...res}
          }
        }
        return res
      },

      loadQuickList() {
        return new Promise((resolve, reject) => {
          this.selectArray = []
          this.rightSort = []
          queryQuickList(this.userInfo.account_id).then(res => {

              this.quickList = res.resultset
              this.resultList = res.resultset
              if(res.resultset.length == 0) {
                  queryQuickList("1").then(resullt => {
                      this.quickList = resullt.resultset
                      this.resultList = resullt.resultset
                  })
              }
              for (let j of this.resultList) {
                let obj = {
                  menuname: j.menuname,
                  menu_uuid: j.menu_uuid,
                  menuicon: j.menuicon,
                  menuurl: j.menuurl,
                  parentmenucode: j.parentmenucode,
                }
                this.selectArray.push(obj)
                this.rightSort.push(obj)
                this.checkKeys.push(j.menu_uuid)
              }
            resolve(this.quickList)
          })
        })
      },

      // 展开节点的方法
      onExpand(expandedKeys) {
        this.expandedKeys = expandedKeys;
        this.autoExpandParent = false;
      },

      // modal完成的方法
      handleTreeOk() {
        for (let i of this.rightSort) {
          let num = this.rightSort.findIndex(o => o.menu_uuid === i.menu_uuid)
          this.rightSort[num].display_order = num
        }
        addQuickList(this.userInfo.account_id, this.rightSort).then(res => {
          this.loadQuickList()
          this.$message.success('添加成功');
          this.addShow = false
        })
      },

      // modal关闭的方法
      handleCancel() {
        this.addShow = false
      },

      loadTreeData() {
        let arr = []
        if (this.apps.length === 0 && this.menus.length > 0) {
          this.treeData = [{
            title: this.menus[0].title,
            key: this.menus[0].key,
            disableCheckbox: true,
            data: this.menus[0].data,
            children: this.changTreeKeys(this.menus[0].children)
          }]
          this.loading = false
        } else {
          for (let i in this.apps) {
            let d = this.apps[i]
            menuLoad(d.app_uuid, this.userInfo.account_id, this.userInfo.deptuuid, this.userInfo.manageunituuid).then(res => {
              let obj = {
                title: d.app_name ? d.app_name : d.short_name,
                key: d.app_uuid,
                disableCheckbox: true,
                data: d
              }
              if (res.length > 0) {
                obj.children = res
              }
              arr.push(obj)
              this.treeData = arr
              this.loading = false
              // for( let j of this.quickList ){
              //   this.checkKeys.push(j.menu_uuid)
              //   console.log(this.checkKeys);
              // }
            })
          }
        }
      },

      // modal框开启方法
      addQuick() {
        this.addShow = true
      },

        //  tree选中事件
        treeCheck() {
            this.selectArray = []
            this.rightSort = []
            for (let i in this.checkKeys) {
                let obj = {}
                let item = this.checkKeys[i]
                let oneSelect = this.querySelectTree(item, this.treeData)
                if (oneSelect) {
                    if (oneSelect.data.issystem !== '1') {
                        if(oneSelect.children === undefined){
                            menuCode2RealUrl(oneSelect.key).then(res => {
                                if (res.result.menuurl) {
                                    obj = {
                                        menuname: oneSelect.data.menuname,
                                        menu_uuid: oneSelect.data.menu_uuid ? oneSelect.data.menu_uuid : oneSelect.data.menucode,
                                        menuicon: oneSelect.data.menuicon,
                                        menuurl: res.result.menuurl,
                                        parentmenucode: oneSelect.data.parentmenucode,
                                    }
                                    this.selectArray.push(obj)
                                    this.rightSort.push(obj)
                                }
                            })
                        }
                    } else {
                        if (oneSelect.data.menuurl) {
                            obj = {
                                menuname: oneSelect.data.menuname,
                                menu_uuid: oneSelect.data.menu_uuid ? oneSelect.data.menu_uuid : oneSelect.data.menucode,
                                menuicon: oneSelect.data.menuicon,
                                menuurl: oneSelect.data.menuurl,
                                parentmenucode: oneSelect.data.parentmenucode,
                            }
                            this.selectArray.push(obj)
                            this.rightSort.push(obj)
                        }
                    }
                }
            }
        },

      // 递归修改树结构
      changTreeKeys(array) {
        let arr = []  //一个children的集合

        for (let i in array) {
          let list = array[i] //children里面的每一个children 判断每一个children里面还有没有更下级的children 如果还有，就调用递归
          if (list.children) {   //遍历出每一个
            list.key = list.data.menu_uuid
            for (let j in list.children) {
              let item = list.children[j]
              if (item.children) { //又有子集
                this.changTreeKeys(item.children)
              } else {
                item = {
                  title: item.title,
                  key: item.data.menu_uuid,
                  data: item.data,
                }
                list.children[j] = item
              }

            }
          } else {
            array[i] = {
              'title': list.title,
              'key': list.data.menu_uuid,
              'data': list.data,
            }
            return array
          }
        }
      },

      // 递归找到每一个选中树节点的数据
      querySelectTree(id, array) {
        for (const aa of array) {
          if (aa.data.menucode === id || aa.data.menu_uuid === id || aa.key === id) {
            return aa
          } else if (aa.children && aa.children.length > 0) {
            const xx = this.querySelectTree(id, aa.children)
            if (xx) {
              return xx
            }
          }
        }
      },

      goTodo(item) {
        this.$store.dispatch('SetCurrentMenuCode', item.menu_uuid).then(() => {
            this.$multiTab.open(item.menuurl, item.menuname)
        })
      },

      // 大分类点击事件
      itemClick(type, id) {
        if (id) {
          this.firstClick = false
          this.itemActive = id
          menuLoad(id, this.userInfo.account_id, this.userInfo.deptuuid, this.userInfo.manageunituuid).then(o => {
            this.$store.commit('SET_MENUS', o);
          })
          return
        }
        switch (type) {
          case 10 :
            this.firstClick = true
            this.itemActive = type
            break;
          default :
            this.firstClick = false
            this.itemActive = type
            break;
        }
      }
    }
  }
</script>

<style lang="less">
  .font26 {
    font-size: 26px;
  }

  .menu-footer {
    .ant-modal-body {
      display: flex
    }

    .ghost {
      opacity: 0.5;
      background: #c8ebfb;
    }
  }
</style>>

